import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Articles from "@/pages/Articles";
import Article from "@/pages/Article";
import Hello from "@/pages/Hello";
import { WhatsAppFab } from "@/components/landing/WhatsAppFab";
import { trackEvent, trackPageView } from "@/lib/analytics";
import { captureUtmOnce } from "@/lib/utm";

function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    captureUtmOnce();
    trackPageView(location.pathname + location.search);
    if (location.pathname === "/hello") {
      trackEvent("hello_landing_view", { page_path: location.pathname });
    }
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsListener />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/hello" element={<Hello />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<Article />} />
        </Routes>
        <WhatsAppFab />
      </BrowserRouter>
    </div>
  );
}

export default App;
